import React from "react";
import Lottie from "lottie-react";
import noCar from "../../assets/noCarPremium.json";
import "./style.css";

export default function VehicleNotAttachedGraphic() {
  return (
    <div className="pi-vehicle-unlinked" aria-hidden="true">
      <div className="pi-vehicle-unlinked__glow" />
      <Lottie
        animationData={noCar}
        autoplay
        loop
        className="pi-vehicle-unlinked__lottie"
      />
    </div>
  );
}
